//Here we can send object of words and the message to be formatted, like Mustache js
export const getFormattedMessage = (objectOfWords, message) =>
  Object.keys(objectOfWords)
    .reduce((newMessage, key) => newMessage.replaceAll(`{{${key}}}`, objectOfWords[key]), message)
    .trim();
